module.exports = __webpack_public_path__ + "img/shop-img.43122618.png";